<div class="pdw" style="border-radius:28px;overflow:hidden;box-shadow:0 4px 6px -1px rgba(0,0,0,.05),0 24px 48px -12px rgba(0,0,0,.1);max-width:1280px;margin:24px auto;">

  <!-- ══ LOADING ══════════════════════════════════════════════════════════════ -->
  <div *ngIf="isLoading"
       style="display:flex;align-items:center;justify-content:center;height:300px;background:var(--ivory);">
    <div style="text-align:center">
      <div style="width:40px;height:40px;border:3px solid var(--border);border-top-color:var(--gold);
                  border-radius:50%;animation:spin 0.8s linear infinite;margin:0 auto 12px;"></div>
      <p style="font-size:13px;color:var(--muted);font-weight:500">Loading property...</p>
    </div>
  </div>

  <!-- ══ EVERYTHING BELOW IS INSIDE ng-container ═════════════════════════════ -->
  <ng-container *ngIf="!isLoading">

    <!-- ══ HERO ══════════════════════════════════════════════════════════════ -->
    <div class="pdw-hero as">
      <img *ngIf="selectedImage"
           class="pdw-hero-bg"
           [src]="selectedImage"
           [alt]="property.name || 'Property image'"
           (error)="onHeroImageError()">
      <div class="pdw-hero-overlay"></div>

      <div class="pdw-hero-top af d2">
        <span class="pdw-type-badge" *ngIf="property.propertyType">{{ property.propertyType }}</span>
        <span class="pdw-type-badge" *ngIf="property.type">For {{ property.type }}</span>
        <span class="pdw-type-badge" *ngIf="property.ageOfProperty">{{ property.ageOfProperty }}</span>
      </div>

      <div class="pdw-hero-bottom">
        <div class="au d1">
          <span class="verified-pill">
            <span class="check-wrap" aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" style="display:block">
                <path class="check-path" d="M2 5.2 L4.2 7.5 L8.2 3"/>
              </svg>
            </span>
            {{ property.isSoldOut ? 'SOLD OUT' : 'AVAILABLE' }}
          </span>
          <span class="verified-pill premium ml-4" *ngIf="property.isPropertyVerified">
            <span class="check-wrap" aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" style="display:block">
                <path class="check-path" d="M2 5.2 L4.2 7.5 L8.2 3"/>
              </svg>
            </span>
            Legal Verified
          </span>
          <span class="verified-pill exclusive ml-4" *ngIf="property.isExclusive">
            <span class="check-wrap" aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" style="display:block">
                <path class="check-path" d="M5 1 L6.2 3.8 L9.5 4.1 L7.2 6.2 L7.9 9.5 L5 7.8 L2.1 9.5 L2.8 6.2 L0.5 4.1 L3.8 3.8 Z"/>
              </svg>
            </span>
            Exclusive
          </span>
          <span class="verified-pill high-demand ml-4" *ngIf="property.isHighDemand">
            <span class="check-wrap" aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" style="display:block">
                <path class="check-path" d="M5 1 L5 6 M5 6 Q5 9 8 8 M5 6 Q5 9 2 8"/>
              </svg>
            </span>
            High Demand
          </span>
          <span class="verified-pill investment ml-4" *ngIf="property.isInvestmentGrade">
            <span class="check-wrap" aria-hidden="true">
              <svg width="10" height="10" viewBox="0 0 10 10" style="display:block">
                <path class="check-path" d="M1 7 L3.5 4 L5.5 6 L8 2"/>
              </svg>
            </span>
            Investment Grade
          </span>
        </div>

        <h1 class="serif au d2"
            style="font-size:clamp(1.8rem,4vw,3.2rem);color:#fff;margin:8px 0 5px;line-height:1.1;letter-spacing:-.5px;">
          {{ property.name }}
        </h1>
        <p class="au d3" style="color:rgba(255,255,255,.7);font-size:13px;font-weight:500;margin:0;">
          {{ property.address }}{{ property.cityName ? ', ' + property.cityName : '' }}{{ property.stateName ? ', ' + property.stateName : '' }}
          <span *ngIf="property.microMarket?.micromarketName" style="margin:0 6px;opacity:.5">·</span>
          {{ property.microMarket?.micromarketName }}
        </p>
      </div>
    </div>

    <!-- ══ THUMBNAIL STRIP ═══════════════════════════════════════════════════ -->
    <div class="pdw-thumbs" *ngIf="property.galleryImage?.length">
      <div *ngFor="let img of property.galleryImage"
           class="pdw-thumb"
           [class.active]="selectedImage === img"
           (click)="onSelectImage(img)">
        <img [src]="img" [alt]="property.name" loading="lazy">
        <button type="button"
                class="pdw-thumb-del"
                (click)="$event.stopPropagation(); onDeleteImage(property._id, img, 'gallery')"
                title="Delete image">
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- ══ TAB BAR — inside ng-container, type="button" on every button ══════ -->
    <div style="background:linear-gradient(180deg,#F5F3FF 0%,#FAFAF7 100%);
                border-bottom:1px solid #E5E3DC;padding:0 36px;">
      <div style="display:flex;gap:0;">
        <button
          *ngFor="let tab of tabs"
          type="button"
          (click)="$event.preventDefault(); setActiveTab(tab.key)"
          style="padding:14px 20px;font-size:13px;cursor:pointer;
                 background:none;border:none;border-left:none;border-right:none;border-top:none;
                 border-bottom:2.5px solid transparent;
                 transition:color .15s ease,border-color .15s ease;
                 outline:none;"
          [style.color]="activeTab === tab.key ? '#7C3AED' : '#9CA3AF'"
          [style.borderBottomColor]="activeTab === tab.key ? '#7C3AED' : 'transparent'"
          [style.fontWeight]="activeTab === tab.key ? '700' : '500'">
          {{ tab.label }}
        </button>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         TAB: PROPERTY
    ══════════════════════════════════════════════════════════════════════ -->
    <div *ngIf="activeTab === 'property'" style="padding:32px 36px;background:var(--ivory);display:flex;flex-direction:column;gap:20px;">

      <!-- TOP META -->
      <div style="display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:space-between;gap:28px;margin-bottom:36px;" class="rv">
        <div style="flex:1;min-width:280px;">
          <p style="font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:var(--gold);margin:0 0 5px;">
            {{ property.builder || 'Developer' }}
          </p>
          <h2 class="serif" style="font-size:2rem;color:var(--charcoal);margin:0 0 10px;line-height:1.2;">
            {{ property.name }}
          </h2>
          <p style="font-size:13.5px;color:var(--muted);line-height:1.75;max-width:540px;margin:0 0 16px;">
            {{ property.shortDescription }}
          </p>
          <div style="display:flex;flex-wrap:wrap;gap:8px;">
            <span *ngIf="property.possessionYear"
              class="pdw-tag" style="background:#FEF9EC;border:1px solid #F0D98A;color:#92700A;">
              📅 Possession {{ property.possessionYear }}
            </span>
            <span *ngIf="property.possession"
              class="pdw-tag" style="background:#EFF6FF;border:1px solid #BFDBFE;color:#1D4ED8;">
              🏗 {{ property.possession }}
            </span>
            <span *ngIf="property.reraNumber"
              class="pdw-tag" style="background:#F0FDF4;border:1px solid #BBF7D0;color:#166534;">
              ✓ RERA: {{ property.reraNumber }}
            </span>
          </div>
        </div>

        <!-- Price Cards -->
        <div style="display:flex;flex-wrap:wrap;gap:12px;">
          <div *ngFor="let item of property.price; let i = index"
               class="pdw-price-card au"
               [style.animation-delay]="(0.1 + i * 0.1) + 's'">
            <p style="font-size:9px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:rgba(255,255,255,.45);margin:0 0 4px;">
              {{ item.bhkType }}
            </p>
            <p class="serif" style="font-size:1.6rem;color:#fff;margin:0 0 3px;line-height:1;">
              {{ item.price | inrShort }}
            </p>
            <p style="font-size:10px;color:rgba(255,255,255,.4);margin:0 0 6px;">
              {{ item.areaInSq | numberFormat }} sqft · ₹{{ item.averagePrice | numberFormat }}/sqft
            </p>
            <p *ngIf="item.propertyStructureType"
               style="font-size:9px;font-weight:700;color:var(--gold-light);letter-spacing:1px;text-transform:uppercase;margin:0;">
              {{ item.propertyStructureType }}
            </p>
          </div>
        </div>
      </div>

      <div class="pdw-divider"></div>

      <!-- STATS GRID -->
      <div class="rv" style="margin-bottom:40px;">
        <div class="pdw-sec"><span>Property Details</span></div>
        <div class="pdw-stat-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(145px,1fr));gap:10px;">
          <div class="pdw-stat" *ngIf="property.landArea">
            <p class="pdw-stat-label">Land Area</p>
            <p class="pdw-stat-val">{{ property.landArea | numberFormat }} <span class="pdw-stat-unit">sqft</span></p>
          </div>
          <div class="pdw-stat" *ngIf="property.superBuiltUpArea">
            <p class="pdw-stat-label">Super Built-up</p>
            <p class="pdw-stat-val">{{ property.superBuiltUpArea | numberFormat }} <span class="pdw-stat-unit">sqft</span></p>
          </div>
          <div class="pdw-stat" *ngIf="property.builtUpArea">
            <p class="pdw-stat-label">Built-up Area</p>
            <p class="pdw-stat-val">{{ property.builtUpArea | numberFormat }} <span class="pdw-stat-unit">sqft</span></p>
          </div>
          <div class="pdw-stat" *ngIf="property.structure">
            <p class="pdw-stat-label">Structure</p>
            <p class="pdw-stat-val">{{ formatBuildingStr(property.structure) }}</p>
          </div>
          <div class="pdw-stat">
            <p class="pdw-stat-label">Floor Count</p>
            <p class="pdw-stat-val">{{ property.floorCount || '—' }}</p>
          </div>
          <div class="pdw-stat">
            <p class="pdw-stat-label">Basement</p>
            <p class="pdw-stat-val">{{ property.basementCount || '0' }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.facing">
            <p class="pdw-stat-label">Facing</p>
            <p class="pdw-stat-val">{{ property.facing }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.furnishing">
            <p class="pdw-stat-label">Furnishing</p>
            <p class="pdw-stat-val">{{ property.furnishing }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.bedrooms">
            <p class="pdw-stat-label">Bedrooms</p>
            <p class="pdw-stat-val">{{ property.bedrooms }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.parking">
            <p class="pdw-stat-label">Parking</p>
            <p class="pdw-stat-val">{{ property.parking }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.parkingCapacity">
            <p class="pdw-stat-label">Parking Cap.</p>
            <p class="pdw-stat-val">{{ property.parkingCapacity }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.propertyType">
            <p class="pdw-stat-label">Type</p>
            <p class="pdw-stat-val">{{ property.propertyType }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.possessionYear">
            <p class="pdw-stat-label">Possession Yr</p>
            <p class="pdw-stat-val">{{ property.possessionYear }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.pinCode">
            <p class="pdw-stat-label">Pin Code</p>
            <p class="pdw-stat-val">{{ property.pinCode }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.reraNumber">
            <p class="pdw-stat-label">RERA</p>
            <p class="pdw-stat-val" style="font-size:12px;">{{ property.reraNumber }}</p>
          </div>
          <div class="pdw-stat" *ngIf="property.averagePrice">
            <p class="pdw-stat-label">Avg. Price</p>
            <p class="pdw-stat-val">₹{{ property.averagePrice | numberFormat }}<span class="pdw-stat-unit">/sqft</span></p>
          </div>
        </div>
      </div>

      <div class="pdw-divider"></div>

      <!-- PRICING BREAKDOWN -->
      <div class="rv mt-9 mb-0">
        <div class="pdw-sec"><span>Pricing Breakdown</span></div>
        <div class="grid grid-cols-3 gap-3 mb-4">
          <div class="bg-gradient-to-br from-slate-900 to-slate-700 rounded-2xl p-4 text-white">
            <p class="text-[9px] font-bold uppercase tracking-widest text-slate-400 mb-1">Units Available</p>
            <p class="text-2xl font-black">{{ property.price?.length || 0 }}</p>
            <p class="text-[10px] text-slate-400 mt-1">configurations</p>
          </div>
          <div class="bg-gradient-to-br from-amber-50 to-yellow-50 border border-amber-200 rounded-2xl p-4">
            <p class="text-[9px] font-bold uppercase tracking-widest text-amber-600 mb-1">Starting From</p>
            <p class="text-2xl font-black text-slate-900">{{ getMinPrice() | inrShort }}</p>
            <p class="text-[10px] text-amber-600 mt-1">lowest price</p>
          </div>
          <div class="bg-gradient-to-br from-indigo-50 to-blue-50 border border-indigo-200 rounded-2xl p-4">
            <p class="text-[9px] font-bold uppercase tracking-widest text-indigo-600 mb-1">Up To</p>
            <p class="text-2xl font-black text-slate-900">{{ getMaxPrice() | inrShort }}</p>
            <p class="text-[10px] text-indigo-500 mt-1">highest price</p>
          </div>
        </div>

        <div class="bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-sm">
          <table class="w-full border-collapse text-sm">
            <thead>
              <tr class="bg-slate-900 text-white">
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-left">#</th>
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-left">Unit Type</th>
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-left">BHK</th>
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-right">Area (sqft)</th>
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-right">Rate (₹/sqft)</th>
                <th class="px-5 py-3.5 text-[9px] font-bold uppercase tracking-[1.5px] text-slate-400 text-right">Total Price</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of property.price; let i = index; let last = last"
                  class="group transition-all duration-200 ease-in-out cursor-default"
                  [class.border-b]="!last" [class.border-gray-100]="!last"
                  [class.bg-amber-50]="hoveredPriceRow === item._id"
                  [class.bg-white]="hoveredPriceRow !== item._id"
                  (mouseenter)="hoveredPriceRow = item._id"
                  (mouseleave)="hoveredPriceRow = null">
                <td class="px-5 py-4">
                  <span class="w-6 h-6 rounded-full bg-slate-100 group-hover:bg-amber-200 text-slate-500
                               group-hover:text-amber-800 text-[10px] font-bold flex items-center justify-center transition-all duration-200">
                    {{ i + 1 }}
                  </span>
                </td>
                <td class="px-5 py-4">
                  <span class="inline-flex items-center gap-1.5 text-[10px] font-bold px-3 py-1 rounded-full transition-all duration-200"
                        [ngClass]="getPriceStructureBadgeClass(item.propertyStructureType)">
                    <span class="w-1.5 h-1.5 rounded-full bg-current opacity-60"></span>
                    {{ item.propertyStructureType || '—' }}
                  </span>
                </td>
                <td class="px-5 py-4">
                  <span class="font-bold text-slate-800 capitalize group-hover:text-amber-900 transition-colors duration-200">
                    {{ item.bhkType }}
                  </span>
                </td>
                <td class="px-5 py-4 text-right">
                  <span class="font-semibold text-slate-600 group-hover:text-slate-800 transition-colors duration-200">
                    {{ item.areaInSq | numberFormat }}
                  </span>
                  <span class="text-[10px] text-slate-400 ml-1">sq.ft</span>
                </td>
                <td class="px-5 py-4 text-right">
                  <span class="inline-flex items-center text-[11px] font-bold text-blue-700 bg-blue-50
                               group-hover:bg-blue-100 px-3 py-1 rounded-full transition-all duration-200">
                    ₹{{ item.averagePrice | numberFormat }}
                  </span>
                </td>
                <td class="px-5 py-4 text-right">
                  <div class="flex flex-col items-end gap-0.5">
                    <span class="text-base font-black text-slate-900 group-hover:text-amber-900 transition-colors duration-200">
                      {{ item.price | inrShort }}
                    </span>
                    <div class="h-0.5 bg-gray-100 rounded-full w-16 overflow-hidden">
                      <div class="h-full bg-amber-400 rounded-full transition-all duration-500"
                           [style.width]="getPriceBarWidth(item.price) + '%'"></div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pdw-divider"></div>

      <!-- TWO-COLUMN -->
      <div class="pdw-two-col" style="display:grid;grid-template-columns:1fr 1fr;gap:52px;">

        <!-- LEFT -->
        <div>
          <div class="rv" style="margin-bottom:36px">
            <div class="pdw-sec"><span>About The Project</span></div>
            <p style="font-size:14px;color:var(--muted);line-height:1.85;white-space:pre-line;">{{ property.description }}</p>
          </div>

          <div class="rv" style="margin-bottom:36px">
            <div class="pdw-sec"><span>Amenities</span></div>
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              @for (amenity of getVisibleAmenities(property?.amenities); track amenity.key) {
                <span class="pdw-amenity">
                  <svg style="width:13px;height:13px;flex-shrink:0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path [attr.d]="amenity.icon" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ amenity.label }}
                </span>
              } @empty {
                <p style="font-size:12px;color:var(--muted);font-style:italic;">No amenities listed.</p>
              }
            </div>
          </div>

          <div class="rv" style="margin-bottom:36px" *ngIf="property.additionalRooms?.length">
            <div class="pdw-sec"><span>Additional Rooms</span></div>
            <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px;">
              @for (room of property.additionalRooms; track room) {
                <div class="pdw-room" *ngIf="room !== 'None'">
                  <div class="pdw-room-icon"><i [class]="getRoomIcon(room)"></i></div>
                  <span style="font-size:12px;font-weight:600;color:var(--deep)">{{ room }}</span>
                </div>
              }
            </div>
          </div>

          <div class="rv" style="margin-bottom:36px" *ngIf="property.nearbyPlaces?.length">
            <div class="pdw-sec"><span>Nearby Places</span></div>
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              <span *ngFor="let place of property.nearbyPlaces"
                class="pdw-tag" style="background:#F0FDF4;border:1px solid #86EFAC;color:#166534;">
                📍 {{ place }}
              </span>
            </div>
          </div>

          <div class="rv" style="margin-bottom:36px" *ngIf="property.livingEnvironment?.length">
            <div class="pdw-sec"><span>Living Environment</span></div>
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              <span *ngFor="let env of property.livingEnvironment"
                class="pdw-tag" style="background:#F0FDFA;border:1px solid #99F6E4;color:#0F766E;">
                🌿 {{ env }}
              </span>
            </div>
          </div>

          <div class="rv" style="margin-bottom:36px" *ngIf="property.communityCategory || property.sellerProfile">
            <div class="pdw-sec"><span>Community Info</span></div>
            <div style="background:#fff;border:1px solid var(--border);border-radius:18px;overflow:hidden;">
              <div *ngIf="property.communityCategory" class="pdw-info-row">
                <div class="pdw-info-icon" style="background:#F5F3FF;">
                  <svg style="width:17px;height:17px" fill="none" stroke="#7C3AED" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                  </svg>
                </div>
                <div>
                  <p class="pdw-stat-label" style="margin:0 0 3px">Community Category</p>
                  <p style="font-size:13px;font-weight:700;color:var(--deep);margin:0">{{ property.communityCategory }}</p>
                </div>
              </div>
              <div *ngIf="property.sellerProfile" class="pdw-info-row">
                <div class="pdw-info-icon" style="background:#FFF7ED;">
                  <svg style="width:17px;height:17px" fill="none" stroke="#EA580C" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
                <div>
                  <p class="pdw-stat-label" style="margin:0 0 3px">Seller Profile</p>
                  <p style="font-size:13px;font-weight:700;color:var(--deep);margin:0">{{ property.sellerProfile }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="rv" *ngIf="property?.propUpdatedBy?.name">
            <div class="pdw-sec"><span>Last Updated By</span></div>
            <div class="pdw-updater">
              <div class="pdw-updater-av">{{ property.propUpdatedBy.name.charAt(0).toUpperCase() }}</div>
              <div>
                <p style="font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:1.2px;color:rgba(255,255,255,.4);margin:0 0 3px">Property Manager</p>
                <p style="font-size:14px;font-weight:700;color:#fff;margin:0 0 2px">{{ property.propUpdatedBy.name }}</p>
                <p style="font-size:11px;color:rgba(255,255,255,.45);margin:0">
                  {{ property.propUpdatedBy.role }}
                  <span *ngIf="property.propUpdatedBy.email"> · {{ property.propUpdatedBy.email }}</span>
                </p>
              </div>
            </div>
          </div>
        </div><!-- /LEFT -->

        <!-- RIGHT -->
        <div>
          <div class="rv">
            <div class="pdw-sec"><span>Assigned Advisors</span></div>
            <div style="display:flex;flex-direction:column;gap:14px;">
              @for (adv of advisor(); track adv._id) {
                <div class="pdw-advisor">
                  <div style="display:flex;align-items:center;gap:14px;margin-bottom:16px">
                    <div style="position:relative">
                      @if (adv.advisorImg) {
                        <img [src]="adv.advisorImg" [alt]="adv.name"
                             style="width:52px;height:52px;border-radius:14px;object-fit:cover;border:2px solid var(--border)">
                      } @else {
                        <div style="width:52px;height:52px;border-radius:14px;background:linear-gradient(135deg,var(--charcoal),var(--deep));display:flex;align-items:center;justify-content:center;font-family:'DM Serif Display',serif;font-size:22px;color:var(--gold)">
                          {{ adv.name?.charAt(0)?.toUpperCase() }}
                        </div>
                      }
                      <div style="position:absolute;bottom:-2px;right:-2px;width:12px;height:12px;background:#22C55E;border:2px solid #fff;border-radius:50%"></div>
                    </div>
                    <div style="flex:1;min-width:0">
                      <p class="serif" style="font-size:15px;color:var(--charcoal);margin:0 0 2px">{{ adv.name }}</p>
                      <p style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1px;color:var(--gold);margin:0">{{ adv.specialization }}</p>
                    </div>
                    <div style="text-align:right;flex-shrink:0" *ngIf="adv.experience">
                      <p style="font-size:13px;font-weight:700;color:var(--charcoal);margin:0">{{ adv.experience }} yrs</p>
                      <p style="font-size:9px;color:var(--muted);margin:0">Experience</p>
                    </div>
                  </div>
                  <div style="display:flex;flex-direction:column;gap:9px;padding-top:14px;border-top:1px solid var(--border)">
                    <div style="display:flex;align-items:center;gap:10px" *ngIf="adv.email">
                      <div style="width:28px;height:28px;background:#EFF6FF;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0">
                        <svg style="width:14px;height:14px" fill="none" stroke="#3B82F6" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                        </svg>
                      </div>
                      <span style="font-size:12px;color:var(--muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ adv.email }}</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:10px" *ngIf="adv.phone">
                      <div style="width:28px;height:28px;background:#F0FDF4;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0">
                        <svg style="width:14px;height:14px" fill="none" stroke="#22C55E" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                        </svg>
                      </div>
                      <span style="font-size:12px;color:var(--muted)">{{ adv.phone }}</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:10px" *ngIf="adv.location">
                      <div style="width:28px;height:28px;background:#FFF7ED;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0">
                        <svg style="width:14px;height:14px" fill="none" stroke="#F97316" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                        </svg>
                      </div>
                      <span style="font-size:12px;color:var(--muted)">{{ adv.location }}</span>
                    </div>
                  </div>
                </div>
              } @empty {
                <div style="text-align:center;padding:48px 24px;background:#fff;border:2px dashed var(--border);border-radius:20px">
                  <div style="width:56px;height:56px;background:var(--blush);border-radius:16px;margin:0 auto 12px;display:flex;align-items:center;justify-content:center">
                    <i class="pi pi-users" style="font-size:22px;color:var(--muted)"></i>
                  </div>
                  <p style="font-size:13px;font-weight:600;color:var(--muted);margin:0">No advisors assigned yet</p>
                </div>
              }
            </div>
          </div>
        </div><!-- /RIGHT -->
      </div><!-- /two-col -->
    </div><!-- /property tab -->

    <!-- ══════════════════════════════════════════════════════════════════════
         TAB: INTELLIGENCE
    ══════════════════════════════════════════════════════════════════════ -->
    <div *ngIf="activeTab === 'intelligence'"
         style="padding:32px 36px;background:var(--ivory);display:flex;flex-direction:column;gap:20px;">

      <ng-container *ngIf="cipData; else noCiIntelligence">

      <!-- Trophy Banner -->
      <div class="flex items-center gap-2.5 px-4 py-2.5 rounded-xl
                  bg-gradient-to-r from-amber-50 to-yellow-100 border border-amber-300">
        <svg class="w-3.5 h-3.5 text-amber-500 shrink-0" fill="currentColor" viewBox="0 0 24 24">
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
        <span class="text-[10px] font-bold tracking-[1.2px] text-amber-800 uppercase">
          {{ cipData?.trophyTags || 'Circled Intelligence · Calculated from property and market data' }}
        </span>
      </div>

      <!-- Verdict -->
      <div class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-4">Verdict</p>
        <div class="bg-gradient-to-br from-amber-50 to-yellow-50 border border-amber-200 rounded-xl p-5">
          <p class="text-[13px] text-slate-600 leading-7 mb-4">
            {{ cipData?.verdict?.summary || 'Analysis not available for this property.' }}
          </p>
          <div class="flex flex-wrap gap-2" *ngIf="cipData?.verdict?.badges?.length">
            <span *ngFor="let badge of cipData?.verdict?.badges"
                  class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[10px] font-bold tracking-[0.5px]"
                  [ngClass]="getBadgeClass(badge.color)">
              <span class="w-1.5 h-1.5 rounded-full" [ngClass]="getBadgeDot(badge.color)"></span>
              {{ badge.label }}
            </span>
          </div>
          <div class="flex flex-wrap gap-2" *ngIf="!cipData?.verdict?.badges?.length">
            <span class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-slate-300 text-slate-400 text-[10px] font-bold">
              No verdict badges available
            </span>
          </div>
        </div>
      </div>

      <!-- Pricing PSF -->
      <div class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-5">Pricing — PSF (₹)</p>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Last Avg Transacted</p>
            <p class="text-3xl font-black text-violet-700">{{ cipData?.pricing?.lastAvgTransacted || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">per sq ft</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Last 5 Transactions Avg</p>
            <p class="text-3xl font-black text-violet-700">{{ cipData?.pricing?.last5TransactionsAvg || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">per sq ft</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Last Transacted Date</p>
            <p class="text-2xl font-black text-slate-800">{{ cipData?.pricing?.lastTransactedDate || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">most recent</p>
          </div>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">UDS Current Rate PSF</p>
            <p class="text-3xl font-black text-violet-700">{{ cipData?.pricing?.udsCurrentRate || '—' }}</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Benchmark PSF</p>
            <p class="text-3xl font-black text-slate-800">{{ cipData?.pricing?.benchmarkPsf || '—' }}</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Ask vs Benchmark</p>
            <div class="flex items-center gap-2 mt-1">
              <span class="text-2xl font-black text-amber-500">{{ cipData?.pricing?.askVsBenchmark || '—' }}</span>
              <span *ngIf="cipData?.pricing?.askVsBenchmark"
                    class="inline-flex items-center gap-1 bg-amber-100 text-amber-600 rounded-full px-2.5 py-0.5 text-[10px] font-semibold">
                <svg class="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        [attr.d]="cipData?.pricing?.askVsBenchmarkDirection === 'below' ? 'M19 9l-7 7-7-7' : 'M5 15l7-7 7 7'"/>
                </svg>
                {{ cipData?.pricing?.askVsBenchmarkDirection || 'above' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Benchmark Records -->
      <div *ngIf="cipData?.transactions?.length" class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <div class="mb-5 flex items-center justify-between gap-3">
          <div>
            <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400">Market Evidence</p>
            <h4 class="mt-1 text-base font-black text-slate-900">Benchmark Records ({{ cipData?.transactions?.length }} records)</h4>
          </div>
          <span class="rounded-full bg-violet-50 px-3 py-1 text-[10px] font-bold uppercase tracking-[.5px] text-violet-600">CI data</span>
        </div>
        <div class="overflow-x-auto rounded-xl border border-slate-100">
          <table class="min-w-full text-left">
            <thead class="bg-slate-50 text-[10px] font-bold uppercase tracking-[.5px] text-slate-400">
              <tr><th class="px-4 py-3">Record</th><th class="px-4 py-3">Source / Property</th><th class="px-4 py-3">Benchmark Date</th><th class="px-4 py-3 text-right">Benchmark PSF</th></tr>
            </thead>
            <tbody class="divide-y divide-slate-100 text-[13px]">
              <tr *ngFor="let transaction of cipData?.transactions; let i = index">
                <td class="px-4 py-3 font-medium text-slate-700">{{ i + 1 }}</td>
                <td class="px-4 py-3 font-semibold text-slate-800">{{ transaction.source || '—' }}</td>
                <td class="px-4 py-3 text-slate-500">{{ transaction.date }}</td>
                <td class="px-4 py-3 text-right font-black text-violet-700">{{ transaction.psf }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-3 text-[12px] text-slate-500">Saved benchmark evidence used for this CI. Only available records are shown.</p>
      </div>

      <!-- Valuation & Rental -->
      <div class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-5">Valuation &amp; Rental</p>
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2 leading-tight">Adjusted Current Value (UDS)</p>
            <p class="text-xl font-black text-violet-700 leading-tight mt-2">{{ cipData?.valuation?.adjustedCurrentValue || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1.5">based on UDS area</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2 leading-tight">Avg Rent / Month</p>
            <p class="text-2xl font-black text-slate-800 mt-2">{{ cipData?.valuation?.avgRentMonth || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1.5">{{ cipData?.valuation?.avgRentPA || '' }}</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2 leading-tight">Rental Yield</p>
            <p class="text-3xl font-black text-emerald-600 mt-2">{{ cipData?.valuation?.rentalYield || '—' }}</p>
            <p class="text-[11px] text-emerald-500 font-semibold mt-1.5">{{ cipData?.valuation?.rentalYieldLabel || '' }}</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2 leading-tight">UDS Support vs Close High</p>
            <p class="text-3xl font-black text-slate-800 mt-2">{{ cipData?.valuation?.udsSupport || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1.5">margin buffer</p>
          </div>
        </div>
      </div>

      <!-- Strength Indicators -->
      <div class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-5">Strength Indicators</p>
        <div class="flex flex-col gap-4" *ngIf="cipData?.strengthIndicators?.length; else noStrength">
          <div *ngFor="let ind of cipData?.strengthIndicators"
               class="grid items-center gap-4"
               style="grid-template-columns:160px 1fr 110px">
            <span class="text-[13px] text-slate-500 truncate">{{ ind.label }}</span>
            <div class="h-2 bg-slate-100 rounded-full overflow-hidden">
              <div class="h-full rounded-full bg-gradient-to-r transition-all duration-700"
                   [ngClass]="ind.color === 'emerald' ? 'from-emerald-500 to-emerald-400' : 'from-amber-400 to-yellow-300'"
                   [style.width.%]="ind.widthPercent"></div>
            </div>
            <span class="text-[13px] font-semibold text-right"
                  [ngClass]="ind.color === 'emerald' ? 'text-emerald-500' : 'text-amber-500'">
              {{ ind.value }}
            </span>
          </div>
        </div>
        <ng-template #noStrength>
          <p class="text-[13px] text-slate-400 italic">Strength data not available for this property.</p>
        </ng-template>
      </div>

      <!-- Offer Guidance -->
      <div class="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-5">Offer Guidance</p>
        <div class="flex items-center justify-between bg-violet-50 border border-violet-100 rounded-xl px-4 py-2.5 mb-3">
          <span class="text-[10px] font-bold uppercase tracking-[0.5px] text-slate-400">PSF Range</span>
          <span class="text-[10px] font-bold uppercase tracking-[0.5px] text-violet-600">Per Square Foot</span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
          <div class="bg-gradient-to-br from-amber-50 to-yellow-100 border-2 border-amber-400 rounded-xl p-4">
            <p class="text-[10px] font-bold uppercase tracking-[0.5px] text-amber-800 mb-2">Suggested Offer</p>
            <p class="text-3xl font-black text-amber-900">{{ cipData?.offerGuidance?.suggestedOfferPsf || '—' }}</p>
            <p class="text-[11px] text-amber-700 mt-1">recommended entry</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Close PSF — Low</p>
            <p class="text-2xl font-black text-slate-800">{{ cipData?.offerGuidance?.closePsfLow || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">conservative close</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Close PSF — High</p>
            <p class="text-2xl font-black text-slate-800">{{ cipData?.offerGuidance?.closePsfHigh || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">optimistic close</p>
          </div>
        </div>
        <div class="flex items-center justify-between bg-violet-50 border border-violet-100 rounded-xl px-4 py-2.5 mb-3">
          <span class="text-[10px] font-bold uppercase tracking-[0.5px] text-slate-400">Total Value</span>
          <span class="text-[10px] font-bold uppercase tracking-[0.5px] text-violet-600">UDS Basis</span>
        </div>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5">
          <div class="bg-gradient-to-br from-amber-50 to-yellow-100 border-2 border-amber-400 rounded-xl p-4">
            <p class="text-[10px] font-bold uppercase tracking-[0.5px] text-amber-800 mb-2">Suggested Offer Value</p>
            <p class="text-xl font-black text-amber-900">{{ cipData?.offerGuidance?.suggestedOfferValue || '—' }}</p>
            <p class="text-[11px] text-amber-700 mt-1">recommended</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Likely Close — Low</p>
            <p class="text-xl font-black text-slate-800">{{ cipData?.offerGuidance?.likelyCloseLow || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">floor estimate</p>
          </div>
          <div class="bg-violet-50 border border-violet-100 rounded-xl p-4">
            <p class="text-[10px] font-semibold uppercase tracking-[0.5px] text-slate-400 mb-2">Likely Close — High</p>
            <p class="text-xl font-black text-slate-800">{{ cipData?.offerGuidance?.likelyCloseHigh || '—' }}</p>
            <p class="text-[11px] text-slate-400 mt-1">ceiling estimate</p>
          </div>
        </div>
        <!-- Offer Range Visualisation -->
        <div class="bg-violet-50 border border-violet-100 rounded-xl p-5">
          <p class="text-[10px] font-bold tracking-[1px] uppercase text-slate-400 mb-6">
            Offer Range Visualisation — PSF (₹)
          </p>
          <div class="relative h-1.5 rounded-full mb-8"
               style="background:linear-gradient(90deg,#ede9fe 0%,#7c3aed 40%,#a78bfa 100%)">
            <div class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5
                        bg-violet-700 border-[3px] border-white rounded-full shadow-md" style="left:5%">
              <div class="absolute -top-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-violet-700 whitespace-nowrap">
                {{ cipData?.offerGuidance?.suggestedOfferPsf || '' }}
              </div>
            </div>
            <div class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5
                        bg-slate-500 border-[3px] border-white rounded-full shadow-md" style="left:52%">
              <div class="absolute -top-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-slate-500 whitespace-nowrap">
                {{ cipData?.offerGuidance?.closePsfLow || '' }}
              </div>
            </div>
            <div class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5
                        bg-slate-400 border-[3px] border-white rounded-full shadow-md" style="left:98%">
              <div class="absolute -top-6 right-0 text-[9px] font-bold text-slate-400 whitespace-nowrap">
                {{ cipData?.offerGuidance?.closePsfHigh || '' }}
              </div>
            </div>
          </div>
          <div class="flex justify-between text-[11px]">
            <div>
              <p class="text-slate-400">Suggested offer</p>
              <p class="font-bold text-violet-700 mt-0.5">{{ cipData?.offerGuidance?.suggestedOfferPsf || '—' }}</p>
            </div>
            <div class="text-center">
              <p class="text-slate-400">Close low</p>
              <p class="font-bold text-slate-600 mt-0.5">{{ cipData?.offerGuidance?.closePsfLow || '—' }}</p>
            </div>
            <div class="text-right">
              <p class="text-slate-400">Close high</p>
              <p class="font-bold text-slate-600 mt-0.5">{{ cipData?.offerGuidance?.closePsfHigh || '—' }}</p>
            </div>
          </div>
        </div>
      </div>
      </ng-container>

      <ng-template #noCiIntelligence>
        <div class="bg-white rounded-2xl border border-dashed border-slate-300 px-6 py-12 text-center shadow-sm">
          <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
            <i class="pi pi-sparkles text-xl"></i>
          </div>
          <p class="text-base font-bold text-slate-800">Circled Intelligence is not available yet</p>
          <p class="mx-auto mt-2 max-w-md text-[13px] leading-6 text-slate-500">
            This property will show its benchmark, valuation, offer guidance and market signals here once its CI calculation is generated.
          </p>
        </div>
      </ng-template>
    </div><!-- /intelligence tab -->

    <!-- ══ TAB: INVESTMENT ═══════════════════════════════════════════════════ -->
    <div *ngIf="activeTab === 'investment'" style="padding:32px 36px;background:var(--ivory);">
      <ng-container *ngIf="cipData; else noInvestmentIntelligence">
        <div class="flex items-center justify-between gap-4 mb-5">
          <div>
            <p class="text-[10px] font-bold tracking-[1px] uppercase text-violet-600">Returns</p>
            <h3 class="mt-1 text-xl font-black text-slate-900">Rental &amp; ROI Intelligence</h3>
            <p class="mt-1 text-[13px] text-slate-500">Calculated from the generated CI benchmark, rental and valuation data.</p>
          </div>
          <span class="rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-[11px] font-bold text-emerald-700">CI calculated</span>
        </div>

        <div class="space-y-4">
          <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <p class="mb-4 text-[10px] font-bold tracking-[1px] uppercase text-slate-400">Rental &amp; ROI Intelligence</p>
            <div class="grid grid-cols-2 gap-3 lg:grid-cols-4">
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4">
                <p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Monthly rent</p>
                <p class="mt-2 text-xl font-black text-slate-900">{{ cipData?.valuation?.avgRentMonth || '—' }}</p>
              </div>
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4">
                <p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Annual rent</p>
                <p class="mt-2 text-xl font-black text-slate-900">{{ cipData?.valuation?.avgRentPA || '—' }}</p>
              </div>
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4">
                <p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Rental yield</p>
                <p class="mt-2 text-xl font-black text-emerald-600">{{ cipData?.valuation?.rentalYield || '—' }}</p>
              </div>
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4">
                <p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Rental strength</p>
                <p class="mt-2 text-base font-black text-emerald-600">{{ cipData?.valuation?.rentalYieldLabel || '—' }}</p>
              </div>
            </div>
            <div class="mt-5 rounded-xl border border-violet-100 bg-violet-50 p-4">
              <div class="mb-4 flex items-center justify-between gap-3">
                <p class="text-[10px] font-bold uppercase tracking-[.6px] text-slate-400">Projected rental income · 5 years</p>
                <p class="text-[12px] font-bold text-violet-700">{{ investmentFiveYearRent() }}</p>
              </div>
              <div class="flex h-16 items-end justify-around gap-3 border-b border-violet-100 px-4">
                <div *ngFor="let year of [1, 2, 3, 4, 5]; let last = last" class="flex h-full flex-1 flex-col items-center justify-end gap-1">
                  <span class="w-7 rounded-t-md bg-violet-300" [style.height.%]="40 + year * 12"></span>
                  <span class="text-[9px] font-semibold text-slate-400">Y{{ year }}</span>
                </div>
              </div>
            </div>
          </section>

          <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <p class="text-[10px] font-bold tracking-[1px] uppercase text-violet-600">Score</p>
            <h4 class="mt-1 text-base font-black text-slate-900">Investment Score Breakdown</h4>
            <div class="mt-5 grid gap-x-8 gap-y-4 md:grid-cols-2">
              <div *ngFor="let metric of investmentMetrics()">
                <div class="mb-1.5 flex justify-between text-[11px]"><span class="text-slate-500">{{ metric.label }}</span><span class="font-bold text-slate-700">{{ metric.score }}/100</span></div>
                <div class="h-1.5 overflow-hidden rounded-full bg-slate-100"><div class="h-full rounded-full bg-violet-500" [style.width.%]="metric.score"></div></div>
              </div>
            </div>
          </section>

          <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <p class="text-[10px] font-bold tracking-[1px] uppercase text-violet-600">Wealth</p>
            <h4 class="mt-1 text-base font-black text-slate-900">Wealth Projection</h4>
            <div class="mt-4 grid gap-3 md:grid-cols-3">
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4"><p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Current CI value</p><p class="mt-2 text-xl font-black text-slate-900">{{ cipData?.valuation?.adjustedCurrentValue || cipData?.offerGuidance?.suggestedOfferValue || '—' }}</p></div>
              <div class="rounded-xl border border-violet-100 bg-violet-50 p-4"><p class="text-[10px] font-semibold uppercase tracking-[.5px] text-slate-400">Likely close range</p><p class="mt-2 text-xl font-black text-slate-900">{{ investmentCloseRange() }}</p></div>
              <div class="rounded-xl border border-emerald-100 bg-emerald-50 p-4"><p class="text-[10px] font-semibold uppercase tracking-[.5px] text-emerald-600">Potential savings</p><p class="mt-2 text-xl font-black text-emerald-700">{{ investmentSavings() }}</p></div>
            </div>
            <div class="mt-3 grid grid-cols-3 gap-3 text-center">
              <div *ngFor="let period of [1, 3, 5]" class="rounded-lg border border-violet-100 bg-violet-50 px-3 py-2"><p class="text-[9px] uppercase tracking-[.5px] text-slate-400">{{ period }} year</p><p class="mt-1 text-sm font-black text-violet-700">+{{ period * 8 }}%</p></div>
            </div>
          </section>

          <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
            <p class="text-[10px] font-bold tracking-[1px] uppercase text-violet-600">Investor intelligence</p>
            <div class="mt-2 flex flex-wrap items-center justify-between gap-4"><div><h4 class="text-base font-black text-slate-900">Market evidence</h4><p class="mt-1 text-[13px] text-slate-500">Your offer can be guided by the generated CI benchmark and recent transactions.</p></div><span class="rounded-full bg-slate-900 px-3 py-1.5 text-[11px] font-bold text-white">Available with CI</span></div>
            <div class="mt-4 grid gap-3 sm:grid-cols-3"><div class="rounded-xl bg-slate-50 p-3"><p class="text-[10px] uppercase text-slate-400">Benchmark PSF</p><p class="mt-1 font-black text-slate-800">{{ cipData?.pricing?.benchmarkPsf || '—' }}</p></div><div class="rounded-xl bg-slate-50 p-3"><p class="text-[10px] uppercase text-slate-400">Last transaction PSF</p><p class="mt-1 font-black text-slate-800">{{ cipData?.pricing?.lastAvgTransacted || '—' }}</p></div><div class="rounded-xl bg-slate-50 p-3"><p class="text-[10px] uppercase text-slate-400">Market difference</p><p class="mt-1 font-black text-slate-800">{{ cipData?.pricing?.askVsBenchmark || '—' }}</p></div></div>
          </section>
        </div>
      </ng-container>

      <ng-template #noInvestmentIntelligence>
        <div class="rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-12 text-center shadow-sm"><p class="text-base font-bold text-slate-800">Investment intelligence is not available yet</p><p class="mx-auto mt-2 max-w-md text-[13px] leading-6 text-slate-500">Generate Circled Intelligence for this property to unlock rental, ROI and investment guidance.</p></div>
      </ng-template>
    </div>

    <!-- ══ TAB: LOCATION ════════════════════════════════════════════════════ -->
    <div *ngIf="activeTab === 'location'" style="padding:32px 36px;background:var(--ivory);">
      <div class="mb-5"><p class="text-[10px] font-bold tracking-[1px] uppercase text-violet-600">Location</p><h3 class="mt-1 text-xl font-black text-slate-900">Property location</h3><p class="mt-1 text-[13px] text-slate-500">Address, micro-market and map location for this property.</p></div>
      <div class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div class="flex gap-4">
          <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-rose-50 text-rose-600">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
          </div>
          <div>
            <p class="text-base font-bold leading-6 text-slate-800">{{ property.address }}{{ property.streetName ? ', ' + property.streetName : '' }}</p>
            <p class="mt-1 text-[13px] text-slate-500">{{ property.cityName }}{{ property.stateName ? ', ' + property.stateName : '' }}{{ property.pinCode ? ' — ' + property.pinCode : '' }}</p>
            <span *ngIf="property.microMarket?.micromarketName" class="mt-3 inline-flex rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-[11px] font-bold text-amber-700">{{ property.microMarket.micromarketName }}{{ property.microMarket.cluster ? ' · ' + property.microMarket.cluster : '' }}</span>
          </div>
        </div>
      </div>
      <div class="pdw-map-wrap mt-4" style="height:420px;">
        @if (property.location && property.location.includes('https://')) {
          <div class="pdw-map-overlay"><p style="color:#fff;font-size:12px;font-weight:600;margin:0 0 10px">Open in Google Maps</p><a [href]="property.location" target="_blank" rel="noopener" style="background:var(--gold);color:var(--charcoal);font-size:12px;font-weight:700;padding:8px 22px;border-radius:100px;text-decoration:none;display:inline-block">View Location ↗</a></div>
          <iframe [src]="getSafeUrl(getFormattedAddress(property))" style="width:100%;height:100%;border:0" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        } @else {
          <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;background:#F9FAFB;gap:8px"><svg style="width:34px;height:34px" fill="none" stroke="#D1D5DB" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/></svg><p style="font-size:12px;color:#9CA3AF;font-weight:500">Map location not available</p></div>
        }
      </div>
    </div>

  </ng-container><!-- /!isLoading -->
</div><!-- /pdw -->
